import axios from 'axios'
import IPais from '@/interfaces/pais.interface';
import { BACEN_BRASIL, KOOPON_CORE_API_PAISES } from '@/constants';

export default {
    async obterPaises() {
        try {
            const { data } = await axios.get(`${KOOPON_CORE_API_PAISES}`);

            if (!data) return [];        

            return data
                .filter((p: IPais) => p.codigo != BACEN_BRASIL)
                .map((p: IPais) => {
                    return { ...p, codigo: p.codigo.toString() };
                });
        }
        catch(error) {
            return [];
        }
    },
}